import { compose } from 'recompose';
import CreditNote from './CreditNote';
import { creditNoteAPi } from '../common/base.api';
import apiInterceptor from '../../api/interceptor';

const composedCreditNote = compose(apiInterceptor({ ...creditNoteAPi }))(CreditNote);

export default composedCreditNote;
